<template>
  <div id="app">
    <div class="digi-kalk" ref="container" :class="mobile">
      <v-app>
        <router-view :auth='auth' :db='db' :user='user'></router-view>
      </v-app>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import 'firebase/firestore'

let config = {
  apiKey: "AIzaSyBh7UKUYlpsUEzxqdtzHCcaI-UxnpUZx7E",
  authDomain: "kalk-286b8.firebaseapp.com",
  databaseURL: "https://kalk-286b8.firebaseio.com",
  projectId: "kalk-286b8",
  storageBucket: "kalk-286b8.appspot.com",
  messagingSenderId: "532989019196"
};
firebase.initializeApp(config)
export const db = firebase.firestore()
db.settings({timestampsInSnapshots: true})
export const auth = firebase.auth()
const user_default = {
  expected_salary: null,
  salary: null,
  created_at: null,
  user_id: null,
  education: null,
  education_adjusted: null,
  county: null,
  county_adjusted: null,
  years_in_it: null,
  work_percentage: null,
  field: null,
}

export default {
  name: 'app',
  data () {
    return {
      auth: auth,
      db: db,
      user: user_default,
      user_default: user_default,
      mobile: "mobile"
    }
  },
  mounted () {
    firebase.auth().onAuthStateChanged((firebase_user) => {
      if (firebase_user) {
        this.user.user_id = firebase_user.uid
        // The onSnapshot-part actually runs without the auth state changing
        this.db.collection('users').doc(this.user.user_id)
        .onSnapshot((doc) => {
          let data = doc.data()
          if(data) {
            this.user = data
            if (data.expected_salary) this.$router.replace('report')
          } else {
            this.user = Object.assign({}, this.user_default, {
              user_id: firebase_user.uid
            })
            console.log("lalala")
            this.$router.replace('form')
          }
        })
      } else {
        this.user = Object.assign({}, this.user_default)
      }
    })
    // if (firebase.auth().currentUser) this.user.user_id = firebase.auth().currentUser.uid
    console.log(this.$refs.container.clientWidth)
    this.$refs.container.clientWidth <= 700 ? this.mobile = "mobile" : this.mobile = "desktop"
  }
}
</script>

<style lang="scss">
.digi-kalk {
  font-size: 12px;
  height: 600px;
  @import '../node_modules/vuetify/dist/vuetify';
  * {
    box-sizing: border-box;
  }
  p, h4, h1 {
    font-family: 'Roboto', sans-serif;
    color: rgba(0,0,0,.75);
    font-size: 1.3em;
  }
  h1 {
    font-size: 3em !important;
    font-weight: 900 !important;
    font-family: Roboto, sans-serif !important;
    text-transform: none !important;
  }
  a { 
    text-decoration: none;
    color: rgba(0,0,0,.75);
  }

  .main-row {
    display: flex;
    align-items: center;
    width: 1000px;
    height: 600px;
  }

  .left-column {
    width: 40%;
    align-self:stretch;
    display:flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
  }

  .right-column {
    width: 60%;
    align-self:stretch;
    display:flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
    background-color: #f6f6f6;
  }

  .infobox {
    width: 80%;
    padding: 10%;
    border: 3px solid #107cb2;
  }

  .form {
    width: 80%;
  }

  .no-item-align {
    justify-content: flex-start;
  }

  .mail-error {
    border-color: 3px solid #f44336;
    padding: 5%;
    padding-bottom: 3%;
    width: 70%;
    margin: 0px;
  }
  .mail-success {
    border: 3px solid #4caf50;
    padding: 5%;
    padding-bottom: 3%;
    width: 70%;
  }
  .no-border {
    border: 0;
  }
  .dashed-link {
    color: rgba(0, 0, 0, 0.75);
    border-bottom: 1px dashed rgba(0, 0, 0, 0.75);
  }
  .display-on-mobile {
    display: none;
  }
  input {
    border-radius: 0;
    height: auto;
    box-shadow: none !important;
    border: none;
  }
  input:focus {
    box-shadow: none !important;
  }
  .application--wrap {
    min-height: auto;
  }

}
.mobile {
  height: auto;
  .main-row {
    flex-direction: column;
    width: auto;
    height: auto;
  }
  .left-column {
    width: 100%;
    padding: 20px 0px 20px 0px;
  }
  .right-column {
    width: 100%;
    background-color: #f6f6f6;
    padding: 20px 0px 20px 0px;
  }
  .infobox {
    border: none;
    padding: 30px 30px 20px 30px;
  }
  .display-on-mobile {
    display: block;
  }
  .display-off-mobile {
    display: none;
  }
  .info-over-cards {
    padding: 0;
  }
  .mobile-padding {
    padding: 30px 50px 0 50px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue